<script setup>
import { computed, ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { Icon, Overlay } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { watch } from 'vue'
import { getQueryString } from '@/utils/tools'

const emit = defineEmits(['showTips', 'showLeaderBoard'])

const store = useStore()
const quesInfo = store.getters.getQuesInfo

const show = ref(false)

// 显示
const handleShowOther = (type) => {
  if (type === 'tips') {
    emit('showTips')
  }
  if (type === 'leaderBoard') {
    emit('showLeaderBoard')
  }

  show.value = false
}

const router = useRouter()
const route = useRoute()
const handleJump2 = (url) => {
  console.log(url)

  if (url.startsWith('http')) {
    window.location.href = url
    // window.location.reload()
    return
  } else {
    router.push({
      path: url,
      query: { questionActiveKey: getQueryString('questionActiveKey') }
    })
  }
}

// 是否登录过
const hasLogin = computed(() => {
  return store.getters.getToken
})

// 是否提交过
const hasInfo = computed(() => {
  return !!store.getters.getUserSelection
})

const moreBtnList = ref([])
moreBtnList.value = store.getters.getBtnText.moreBtnList

watch(
  store.getters.getBtnText, (newValue, oldValue) => {
    moreBtnList.value = store.getters.getBtnText.moreBtnList
  }
)

</script>
<template>
  <div class="person-btn" @click="show = true"></div>
  <Overlay :show="show" @click="show = false" duration='0.2'>
    <div class="topArrow"></div>
    <div @click.stop class="more-btn-list">
      <template v-for='(item,index) in moreBtnList'>
        <div class='item' v-if='item.btnText.length != 0 && (item.btnLogin ? hasLogin : true)' @click='handleJump2(item.btnUrl)'>
          <span>{{item.btnText}}</span>
        </div>
      </template>
    </div>
  </Overlay>
</template>
